(function () {
  'use strict';


  /* ── swipe rail ───────────────────────────────────────────── */
  /* Below 760px story.css turns .ugc-grid into a scroll-snapping rail. The
     indicator below it is the same dot component the advisor rail uses, so the
     two controls read as one thing across the page.

     It is driven by the rail's own scroll position rather than by a page index
     the script owns: the rail is swipeable, so the finger — not this file — is
     the source of truth, and a dot can never disagree with what is on screen.
     Above 760px the dots are display:none and this costs nothing. */
  function initRail(root) {
    root.querySelectorAll('[data-ugc-rail]').forEach(function (rail) {
      if (rail.dataset.ugcRailReady === 'true') return;

      var section = rail.closest('.ugc') || document;
      var dots = section.querySelector('[data-ugc-dots]');
      var slides = Array.prototype.slice.call(rail.children);
      if (!dots || slides.length < 2) return;
      rail.dataset.ugcRailReady = 'true';

      /* Measured against the rail's own box rather than offsetLeft: the tiles'
         offsetParent is not guaranteed to be the rail. */
      function centreOf(slide) {
        var r = rail.getBoundingClientRect();
        var s = slide.getBoundingClientRect();
        return (s.left - r.left) + rail.scrollLeft + s.width / 2;
      }

      var buttons = slides.map(function (slide, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.role = 'tab';
        b.setAttribute('aria-label', 'Video ' + (i + 1));
        b.addEventListener('click', function () {
          rail.scrollTo({ left: centreOf(slide) - rail.clientWidth / 2, behavior: 'smooth' });
        });
        return b;
      });
      dots.replaceChildren.apply(dots, buttons);

      function sync() {
        var mid = rail.scrollLeft + rail.clientWidth / 2;
        var live = 0, best = Infinity;
        slides.forEach(function (slide, i) {
          var d = Math.abs(centreOf(slide) - mid);
          if (d < best) { best = d; live = i; }
        });
        buttons.forEach(function (b, i) {
          b.setAttribute('aria-selected', String(i === live));
        });
      }

      rail.addEventListener('scroll', sync, { passive: true });
      addEventListener('resize', sync);
      sync();
    });
  }

  function init(root) {
    initRail(root);
    root.querySelectorAll('[data-ugc-play]').forEach(function (button) {
      if (button.dataset.ugcReady === 'true') return;

      var tile = button.closest('[data-ugc-tile]');
      var video = tile && tile.querySelector('video');
      if (!video) return;

      button.dataset.ugcReady = 'true';

      function restorePlayButton() {
        video.controls = false;
        tile.classList.remove('is-playing');
        button.removeAttribute('aria-hidden');
        button.removeAttribute('tabindex');
      }

      button.addEventListener('click', function () {
        video.controls = true;
        tile.classList.add('is-playing');
        button.setAttribute('aria-hidden', 'true');
        button.setAttribute('tabindex', '-1');

        var playRequest = video.play();
        if (playRequest && typeof playRequest.catch === 'function') {
          playRequest.catch(restorePlayButton);
        }
      });

      video.addEventListener('ended', restorePlayButton);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
}());
